import { Photo, PrintSize } from '../types';
import svgLogoPaths from '../imports/svg-k0toq3gn3f';

interface CertificateProps {
  photo: Photo;
  size: PrintSize;
  editionNumber: number;
  totalEditions: number;
  purchaseDate: string;
}

export function Certificate({ photo, size, editionNumber, totalEditions, purchaseDate }: CertificateProps) {
  return (
    <div className="w-[210mm] h-[297mm] bg-white p-16 flex flex-col justify-between" style={{ fontFamily: 'Georgia, serif' }}>
      {/* Header */}
      <div className="text-center border-b border-neutral-300 pb-8">
        <h1 className="text-4xl tracking-wider mb-2">CERTIFICATE</h1>
        <p className="text-sm tracking-widest text-neutral-600">OF AUTHENTICITY</p>
      </div>

      {/* Main Content */}
      <div className="flex-1 flex items-center gap-12 py-16">
        {/* Photo Preview */}
        <div className="w-1/3 flex-shrink-0">
          <div className="aspect-[3/4] bg-neutral-100 border border-neutral-200 overflow-hidden">
            <img 
              src={photo.imageUrl} 
              alt={photo.title}
              className="w-full h-full object-cover"
            />
          </div>
        </div>

        {/* Certificate Details */}
        <div className="flex-1 text-center space-y-6">
          <div>
            <p className="text-sm tracking-widest text-neutral-500 mb-2">ARTWORK</p>
            <h2 className="text-3xl tracking-tight">{photo.title}</h2>
          </div>

          <div>
            <p className="text-sm tracking-widest text-neutral-500 mb-2">CATEGORY</p>
            <p className="text-xl tracking-wide text-neutral-700">{photo.category}</p>
          </div>

          <div>
            <p className="text-sm tracking-widest text-neutral-500 mb-2">EDITION</p>
            <p className="text-5xl tracking-tight">{editionNumber}/{totalEditions}</p>
          </div>

          <div>
            <p className="text-sm tracking-widest text-neutral-500 mb-2">SIZE</p>
            <p className="text-xl tracking-wide text-neutral-700">{size.name}</p>
            <p className="text-sm text-neutral-500 mt-1">{size.dimensions}</p>
          </div>

          <div>
            <p className="text-sm tracking-widest text-neutral-500 mb-2">MEDIUM</p>
            <p className="text-lg tracking-wide text-neutral-700">Fine Art Print</p>
            <p className="text-sm text-neutral-500 mt-1">Hahnemühle Photo Rag 308gsm</p>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="border-t border-neutral-300 pt-8 space-y-6">
        <div className="flex justify-between items-end">
          <div className="w-1/2">
            <div className="mb-2">
              {/* Main logo signature */}
              <svg width="200" height="60" viewBox="0 0 200 60" xmlns="http://www.w3.org/2000/svg">
                <g transform="translate(5, 2) scale(0.13)">
                  <path d={svgLogoPaths.p310fe900} fill="#111" />
                </g>
              </svg>
            </div>
            <div className="border-t border-neutral-400 pt-2">
              <p className="text-xs tracking-widest text-neutral-500">ARTIST SIGNATURE</p>
            </div>
          </div>

          {/* Date + Wax Seal stacked */}
          <div className="flex flex-col items-center gap-2">
            <p className="text-sm text-neutral-600">{purchaseDate}</p>
          </div>
        </div>

        <div className="text-center">
          <p className="text-xs tracking-wider text-neutral-400">
            This certificate verifies the authenticity and limited edition status of this fine art print.
          </p>
        </div>
      </div>
    </div>
  );
}